import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "register-area pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Job Seeker Sign Up"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_7 = { class: "register-tab" }
const _hoisted_8 = {
  class: "tab-pane fade show active",
  id: "nav-home",
  role: "tabpanel",
  "aria-labelledby": "nav-home-tab"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, null, -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-inner mb-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "firstname1" }, "First Name*", -1)
const _hoisted_14 = { class: "input-area" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/user-2.svg",
  alt: ""
}, null, -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-inner mb-25" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "lastname1" }, "Last Name*", -1)
const _hoisted_19 = { class: "input-area" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/user-2.svg",
  alt: ""
}, null, -1)
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-inner mb-25" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email*", -1)
const _hoisted_24 = { class: "input-area" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/email-2.svg",
  alt: ""
}, null, -1)
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-inner mb-25" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Location", -1)
const _hoisted_29 = { class: "input-area" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-inner mb-25" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password*", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-eye-slash",
  id: "togglePassword"
}, null, -1)
const _hoisted_35 = {
  key: 0,
  style: {"color":"red !important","font-size":"small !important","position":"relative","left":"5px","top":"-1.4rem !important"}
}
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-inner" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "password2" }, "Confirm Password*", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-eye-slash",
  id: "togglePassword2"
}, null, -1)
const _hoisted_40 = {
  key: 0,
  style: {"color":"red !important","font-size":"small !important","position":"relative","left":"5px","top":"3px !important"}
}
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "form-inner mb-25" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "firstname1" }, "Display Picture", -1)
const _hoisted_44 = { class: "button-wrapper" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "col-md-12" }
const _hoisted_48 = { class: "form-agreement form-inner d-flex justify-content-between flex-wrap" }
const _hoisted_49 = { class: "form-group two" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { for: "html1" }, "By registering, you acknowledge and agree to our Privacy Policy.", -1)
const _hoisted_51 = { class: "col-md-12" }
const _hoisted_52 = { class: "form-inner" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = {
  key: 1,
  class: "primry-btn-2",
  type: "button"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<div class=\"login-difarent-way\"><div class=\"row g-4\"><div class=\"col-md-6\"><a href=\"https://myaccount.google.com/\"><img src=\"assets/images/icon/google1.svg\" alt=\"\">Log in with Google</a></div><div class=\"col-md-6\"><a href=\"https://www.facebook.com/\"><img src=\"assets/images/icon/facebook1.svg\" alt=\"\">Log in with Facebook</a></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("form", null, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userForm.first_name) = $event)),
                              type: "text",
                              id: "firstname1",
                              name: "firstname1",
                              placeholder: "Mr. Robert"
                            }, null, 512), [
                              [_vModelText, _ctx.userForm.first_name]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userForm.last_name) = $event)),
                              type: "text",
                              id: "lastname1",
                              name: "lastname1",
                              placeholder: "Jonson",
                              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fillOther && _ctx.fillOther(...args)))
                            }, null, 544), [
                              [_vModelText, _ctx.userForm.last_name]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userForm.email) = $event)),
                              type: "email",
                              id: "email",
                              name: "email",
                              placeholder: "robertjonson@example.com",
                              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setUserName && _ctx.setUserName(...args)))
                            }, null, 544), [
                              [_vModelText, _ctx.userForm.email]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("div", _hoisted_29, [
                            _hoisted_30,
                            _createVNode(_component_Dropdown, {
                              name: "location_id",
                              onChange: _ctx.changeSuburb,
                              modelValue: this.userForm.location_id,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.userForm.location_id) = $event)),
                              options: _ctx.states,
                              ref: "location_id",
                              optionLabel: "name",
                              optionValue: "id",
                              placeholder: "Select Location",
                              class: "w-full",
                              required: ""
                            }, null, 8, ["onChange", "modelValue", "options"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userForm.password) = $event)),
                            type: "password",
                            name: "password",
                            id: "password",
                            placeholder: "Password",
                            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.passCheck && _ctx.passCheck(...args)))
                          }, null, 544), [
                            [_vModelText, _ctx.userForm.password]
                          ]),
                          _hoisted_34
                        ]),
                        (!_ctx.validPass)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.validationMessage), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userForm.password_confirmation) = $event)),
                            type: "password",
                            name: "confirmpassword",
                            id: "password2",
                            placeholder: "Confirm Password",
                            onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.isConfirm && _ctx.isConfirm(...args)))
                          }, null, 544), [
                            [_vModelText, _ctx.userForm.password_confirmation]
                          ]),
                          _hoisted_39
                        ]),
                        (!_ctx.confirmPass)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.confirmText), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("button", {
                              class: "btn primary-btn-2 col-md-2",
                              type: "button",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$refs.file.click()))
                            }, [
                              _createElementVNode("input", {
                                onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.photoChange && _ctx.photoChange(...args))),
                                ref: "file",
                                accept: "image/*",
                                type: "file",
                                id: "photo",
                                name: "photo",
                                style: {"display":"none"}
                              }, null, 544),
                              _createTextVNode(" Upload Image ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("img", {
                          width: "200",
                          ref: "photo",
                          src: _ctx.photoPreview,
                          alt: ""
                        }, null, 8, _hoisted_46)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.is_agree) = $event)),
                              id: "html1"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.is_agree]
                            ]),
                            _hoisted_50
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.createUser && _ctx.createUser(...args))),
                                class: "primry-btn-2",
                                type: "button",
                                disabled: !_ctx.validPass || !_ctx.confirmPass || !_ctx.is_agree
                              }, "Sign Up", 8, _hoisted_53))
                            : (_openBlock(), _createElementBlock("button", _hoisted_54, _hoisted_57))
                        ])
                      ]),
                      _createElementVNode("h6", null, [
                        _createTextVNode("Already have an account? "),
                        _createVNode(_component_router_link, { to: "/login" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Login")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Here")
                      ]),
                      _hoisted_58
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}